export enum Genre {
  Male = "Hombre",
  Female = "Mujer",
}
